export const NO_ASSOCIATED_WORKPLACES_ERROR_MESSAGE = "Facility user has no associated facilities";

export function isNoAssociatedWorkplacesError(error: unknown): boolean {
  return error instanceof Error && error.message === NO_ASSOCIATED_WORKPLACES_ERROR_MESSAGE;
}
